module.exports = __webpack_public_path__ + "img/stock.c4a6f9d6.png";